const randomGenerator = (length = 12, buttonId = 'generatePassword', inputId = 'password') => {
    const $input = $('#' + inputId);
    const $button = $('#' + buttonId);

    if (!$input || !$button) {
        return;
    }

    $button.on('click', function () {
        $input.val(generate());
    });

    function generate() {
        let password = '';
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

        for (var i = 0, n = charset.length; i < length; i++) {
            password += charset.charAt(Math.floor(Math.random() * n));
        }

        return password;
    }
};

export default randomGenerator;
